import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class TrailsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getTrails() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(this.env.url + '/trails/admin?code=' + this.env.key, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTrail(UniqueID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/trail/admin/${UniqueID}?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addTrail(trail) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/trails/admin/create?code=` + this.env.key,
        trail,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateTrail(trail) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/trails/admin/update?code=` + this.env.key,
        trail,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteTrail(UniqueID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url + `/trails/admin/delete/${UniqueID}?code=` + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
